import classNames from 'classnames';
import classes from './ModalTicketInWorking.module.scss';
import React, { FC } from 'react';
import modalBase from '../../../ModalBase/ModalBase.module.scss';

type ModalTicketInWorkingProps = {
  isActive: boolean;
  setActive: (value: boolean) => void;
};
export const ModalTicketInWorking: FC<ModalTicketInWorkingProps> = ({ isActive, setActive }) => {
  return (
    <div className={classNames(modalBase.modal, { [modalBase.active]: isActive })}>
      <div
        className={classNames(modalBase.container, classes.modalContainer)}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}>
        <div className={classes.modalContent}>
          <h2 className={modalBase.title}>Этот билет уже взяли в работу, выберите другой</h2>
        </div>
        <button className={classes.btnUnderstand} onClick={() => setActive(false)}>
          <p>понятно</p>
        </button>
      </div>
    </div>
  );
};
export default ModalTicketInWorking;
